module.exports = __webpack_public_path__ + "img/img-sarita-allen@1x.14101b14.png";